import * as Y from "yjs";
import { fromUint8Array } from "js-base64";

/**
 * Pushes a new list item to a Y.Array within a transaction.
 * Shared by ListView.addItem (live doc) and MealView.addToList (foreign doc).
 */
export function pushListItem(
  doc: Y.Doc,
  yItems: Y.Array<unknown>,
  name: string,
  memberId: number,
): void {
  doc.transact(() => {
    const item = new Y.Map<unknown>();
    item.set("id", crypto.randomUUID());
    item.set("name", name);
    item.set("checked", false);
    item.set("createdBy", memberId);
    yItems.push([item]);
  });
}

/**
 * Appends a list item to a Y.Doc's "items" array and returns ONLY the
 * incremental delta update (base64-encoded), not a full-state snapshot.
 *
 * Use this when writing to a foreign doc (one not managed by useYDoc) so the
 * update journal stays bounded. The returned base64 string is suitable for
 * passing directly to `invoke("save_update", { docId, updateB64 })`.
 */
export function appendListItemDelta(
  doc: Y.Doc,
  name: string,
  memberId: number,
): string {
  const beforeSV = Y.encodeStateVector(doc);
  pushListItem(doc, doc.getArray("items"), name, memberId);
  return fromUint8Array(Y.encodeStateAsUpdate(doc, beforeSV));
}
